import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { visitPaths } from '~libs.desktop.shared.paths';

import { VisitAndAppointmentStatusFilterParam } from './VisitAndAppointmentStatusField.types';
import { visitAndAppointmentStatusFilterStorage } from './VisitAndAppointmentStatusField.storage';

type SyncVisitAndAppointmentStatusFilterParamWithStorageOutput = {
   visitAndAppointmentStatusFilterParam: VisitAndAppointmentStatusFilterParam | null;
   shouldReplaceParam: boolean;
};

export const FILTER_SEPARATOR = ',';

export const visitAndAppointmentStatusToIdMap: Record<VisitAndAppointmentStatus, number> = {
   REGISTERED: 0,
   IN_PROGRESS: 1,
   FINISHED_APPROVED: 2,
   FINISHED_NOT_APPROVED: 3,
   CANCELLED: 4,
};

export const getVisitAndAppointmentStatusesFilterCount = (): number => {
   return Object.keys(visitAndAppointmentStatusToIdMap).length;
};

export const getVisitAndAppointmentStatusFilterSearchParamValueFromStatuses = (
   visitAndAppointmentStatuses: VisitAndAppointmentStatus[]
): VisitAndAppointmentStatusFilterParam => {
   return visitAndAppointmentStatuses.map((status) => visitAndAppointmentStatusToIdMap[status]).join(FILTER_SEPARATOR);
};

export const getPatientPresenceFromSearchParam = (searchParamValue: number): VisitAndAppointmentStatus | null => {
   const foundEntry = Object.entries(visitAndAppointmentStatusToIdMap).find(([, entrySearchParamValue]) => {
      return searchParamValue === entrySearchParamValue;
   });
   return foundEntry ? (foundEntry[0] as VisitAndAppointmentStatus) : null;
};

export const mapVisitAndAppointmentStatusFilterParamToStatuses = (
   visitAndAppointmentStatusSearchParam: string | null
): VisitAndAppointmentStatus[] => {
   if (!visitAndAppointmentStatusSearchParam) {
      return [];
   }
   const chosenStatuses = visitAndAppointmentStatusSearchParam.split(FILTER_SEPARATOR).reduce((set, str) => {
      const num = Number(str);
      if (!Number.isNaN(num)) {
         set.add(num);
      }
      return set;
   }, new Set());
   if (!chosenStatuses.size) {
      return [];
   }
   return (
      // TODO DREGAB-23643 Obsługa błędnych filtrów w url (np. po wpisaniu błędnych wartości "z palca")
      Object.entries(visitAndAppointmentStatusToIdMap).reduce<VisitAndAppointmentStatus[]>((acc, [statusName, id]) => {
         if (chosenStatuses.has(id)) {
            acc.push(statusName as VisitAndAppointmentStatus);
         }
         return acc;
      }, [])
   );
};

export const syncVisitAndAppointmentStatusFilterParamWithStorage = (
   searchParams: URLSearchParams
): SyncVisitAndAppointmentStatusFilterParamWithStorageOutput => {
   const visitAndAppointmentStatusFilterParam = searchParams.get(visitPaths.VISIT_AND_APPOINTMENT_STATUS_SEARCH_PARAM);
   const memoizedVisitAndAppointmentStatusFilter = visitAndAppointmentStatusFilterStorage.getStoredStatuses();

   if (visitAndAppointmentStatusFilterParam) {
      const visitAndAppointmentStatuses = visitAndAppointmentStatusFilterParam.split(FILTER_SEPARATOR).map(Number);
      const visitAndAppointmentStatusesValid = visitAndAppointmentStatuses.every((id) => !isNaN(id));

      if (!visitAndAppointmentStatusesValid) {
         searchParams.delete(visitPaths.VISIT_AND_APPOINTMENT_STATUS_SEARCH_PARAM);
         if (!memoizedVisitAndAppointmentStatusFilter.length) {
            return {
               visitAndAppointmentStatusFilterParam: null,
               shouldReplaceParam: true,
            };
         }
      }

      if (visitAndAppointmentStatusesValid) {
         visitAndAppointmentStatusFilterStorage.setFilter(visitAndAppointmentStatusFilterParam);
         return {
            visitAndAppointmentStatusFilterParam: visitAndAppointmentStatusFilterParam,
            shouldReplaceParam: false,
         };
      }
   }
   if (memoizedVisitAndAppointmentStatusFilter.length) {
      const visitAndAppointmentStatusFilterParam = getVisitAndAppointmentStatusFilterSearchParamValueFromStatuses(
         memoizedVisitAndAppointmentStatusFilter
      );
      searchParams.set(visitPaths.VISIT_AND_APPOINTMENT_STATUS_SEARCH_PARAM, visitAndAppointmentStatusFilterParam);
      return {
         visitAndAppointmentStatusFilterParam: visitAndAppointmentStatusFilterParam,
         shouldReplaceParam: true,
      };
   }
   return {
      visitAndAppointmentStatusFilterParam: null,
      shouldReplaceParam: false,
   };
};
